<!-- TODO: (bug, verify-me) display starts to overlap when col-md-* css classes are active -->
<div class="row align-items-center pt-2 pb-2 access-time-day-row" [formGroup]="dayFormGroup" [ngClass]="{'force-display-invalid-feedback': forceDisplayInvalidFeedback}">
  <div class="d-flex col-md-1 ms-1 pt-1 pb-2">
    <span class="align-self-center">{{ dayFull }}</span>
  </div>
  <div class="d-flex flex-row flex-wrap align-items-center col-md-auto">
    <div class="d-flex align-items-center ms-3 me-3">
      <div class="form-inline ms-1" role="radiogroup" [attr.aria-label]="'aria.allowed-access-time-on' | translate:{dayOfWeek:dayShort}">
        <label class="form-check-label">
          <input class="form-check-input me-0 ps-0"
          type="radio"
          value="n"
          formControlName="allowed"
          [attr.name]="dayShort"
          (click)="disableAllowedTimes()">
          {{ 'content.no-access' | translate }}</label>
        <label class="form-check-label">
          <input class="form-check-input me-0"
          type="radio"
          value="all-day"
          formControlName="allowed"
          [attr.name]="dayShort"
          (click)="disableAllowedTimes()">
          {{ 'content.24-hours' | translate }}</label>
        <label class="form-check-label">
          <input class="form-check-input me-0"
          type="radio"
          value="y"
          formControlName="allowed"
          [attr.name]="dayShort"
          (click)="setAllowedTimes()">
          {{ 'content.allowed-time' | translate }}</label>
      </div>
    </div>

    <div class="">
      <div #daysAllowedTimesInput
           class="d-flex flex-row justify-content-start align-items-center"
           role="group"
           [attr.aria-label]="'aria.allowed-time-range-on' | translate:{dayOfWeek:dayShort}">
        <div #startTimeInput class="d-flex flex-column">
          <label> 
            <div class="visually-hidden">{{ 'aria.start-time-for-dayofweek' | translate:{dayOfWeek:dayShort} }}</div>
            <input id="start-time" type="time" formControlName="startTime">
            <app-validation-errors [displayErrors]="userFormSubmitted"
                                 [element]="startTimeInput"
                                 [errors]="dayFormGroup.controls.startTime.errors"></app-validation-errors>
          </label>
        </div>
        <div class="d-flex"><span class="ps-2 pe-2 text-center">{{ 'content.to' | translate }}</span></div>
        <div #endTimeInput class="d-flex flex-column">
          <label>
            <div class="visually-hidden">{{ 'aria.end-time-for' | translate:{dayOfWeek:dayShort} }}</div>
            <input class="me-2" id="end-time" type="time" formControlName="endTime">
            <app-validation-errors [displayErrors]="userFormSubmitted"
                                 [element]="endTimeInput"
                                 [errors]="dayFormGroup.controls.endTime.errors"></app-validation-errors>
          </label>
        </div>
        <button class="tu-button primary tu-shadow ms-2 apply-to-all-btn"
                type="button"
                (click)="applyTimeToAll()">{{ 'content.apply-to-all' | translate }}</button>
      </div>
      <app-validation-errors [displayErrors]="userFormSubmitted" [element]="daysAllowedTimesInput" [errors]="dayFormGroup.errors"></app-validation-errors>
    </div>
  </div>
</div>
